import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { DepartmentForm } from "./DepartmentForm";

export function CreateDepartmentDialog() {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="default">إضافة دائرة جديدة</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader className="text-right">
          <DialogTitle>إضافة دائرة جديدة</DialogTitle>
          <DialogDescription>
            أضف دائرة جديدة في الوزارة مع تحديد سير عمل الموافقة.
          </DialogDescription>
        </DialogHeader>
        <DepartmentForm setOpen={setOpen} />
      </DialogContent>
    </Dialog>
  );
}
